// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const TwitterBrandColor = createSvgIcon(
  { LeftToRight: <React.Fragment><path fill="#429DF0" d="M24 5.25c-.9.45-1.8.6-2.85.75 1.05-.6 1.8-1.5 2.1-2.7-.9.6-1.95.9-3.15 1.2-.9-.9-2.25-1.5-3.6-1.5-3.15 0-5.55 3-4.8 6-4.05-.15-7.65-2.1-10.2-5.1C.15 6.15.9 9 3 10.5c-.75 0-1.5-.3-2.25-.6 0 2.25 1.65 4.35 3.9 4.95-.75.15-1.5.3-2.25.15.6 1.95 2.4 3.45 4.65 3.45-1.8 1.35-4.5 2.1-7.05 1.8 2.25 1.35 4.8 2.25 7.5 2.25 9.15 0 14.25-7.65 13.95-14.7C22.5 7.2 23.4 6.3 24 5.25z" /></React.Fragment>, },
  'default'
);
